var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "section",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.show,
          expression: "show",
        },
      ],
      staticClass: "mb-4",
    },
    [
      _c("div", {}, [
        _c("h6", { staticClass: "fw-bold" }, [
          _vm._v(
            "\n      " +
              _vm._s(_vm._f("translate")("Payment information")) +
              "\n    "
          ),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "card-container" }, [
        _c("div", { staticClass: "row mb-2" }, [
          _c("div", { staticClass: "col-12" }, [
            _c(
              "label",
              {
                staticClass: "form-label small mb-0",
                attrs: { for: "payu-card-number" },
              },
              [
                _c("small", [
                  _vm._v(_vm._s(_vm._f("translate")("Card Number"))),
                ]),
              ]
            ),
            _vm._v(" "),
            _c("div", {
              ref: "payu-card-number",
              staticClass: "payu-card-form form-control",
              attrs: { type: "text", id: "payu-card-number" },
            }),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-6" }, [
            _c("div", { staticClass: "card-details clearfix mb-2" }, [
              _c("div", { staticClass: "expiration" }, [
                _c(
                  "label",
                  {
                    staticClass: "form-label small mb-0",
                    attrs: { for: "payu-card-date" },
                  },
                  [
                    _c("small", [
                      _vm._v(_vm._s(_vm._f("translate")("Expiration Date"))),
                    ]),
                  ]
                ),
                _vm._v(" "),
                _c("div", {
                  ref: "payu-card-date",
                  staticClass: "payu-card-form form-control",
                  attrs: { type: "text", id: "payu-card-date" },
                }),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-6" }, [
            _c("div", { staticClass: "cvv mb-2" }, [
              _vm._m(0),
              _vm._v(" "),
              _c("div", {
                ref: "payu-card-cvv",
                staticClass: "payu-card-form form-control",
                attrs: { type: "text", id: "payu-card-cvv" },
              }),
            ]),
          ]),
        ]),
        _vm._v(" "),
        _c("div", [_c("InputErrors", { attrs: { name: "cypher" } })], 1),
      ]),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "label",
      { staticClass: "form-label small mb-0", attrs: { for: "payu-card-cvv" } },
      [_c("small", [_vm._v("CVV")])]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }